import {
  InputBaseComponentProps,
  TextField,
  TextFieldProps,
} from '@mui/material';
import React, { RefObject } from 'react';
import { IMaskInput } from 'react-imask';

type IMaskProps = InputBaseComponentProps & {
  onChange: (event: { target: { name: string; value: string } }) => void;
  mask: any; // no export from imask sadly, complex type
  name: string;
};

const IMask = React.forwardRef<HTMLElement, IMaskProps>((props, ref) => {
  const { onChange, mask, ...other } = props;

  return (
    <IMaskInput
      {...other}
      mask={mask}
      inputRef={ref as RefObject<HTMLInputElement>}
      onAccept={(value: string) =>
        onChange({ target: { name: props.name, value } })
      }
      overwrite
    />
  );
});

type InputMaskFieldProps = Omit<
  TextFieldProps,
  'inputComponent' | 'InputProps'
> &
  IMaskProps;

export const InputMaskField: React.FC<InputMaskFieldProps> = ({
  mask,
  ...props
}) => {
  return (
    <TextField
      {...props}
      InputProps={{ inputProps: { mask }, inputComponent: IMask }}
    />
  );
};

export default InputMaskField;
